import { IkonG, type IkonNamn } from "../Ikon";
import { usePausUtanfor } from "../../lib/syns";

// Kretsloppet i inlärningen: avläsning, kontroller, inlärning och ekonomens godkännande, och runt igen.
// Samma formspråk som flödesbanan (mörk panel, noder, signal). Etiketterna är ord som redan står på
// sidan. Grundstilen är sluttillståndet, så reducerad rörelse visar en stilla, komplett cirkel.
const C = 210, R = 150;
const NODER: { namn: string; ikon: IkonNamn; x: number; y: number; lx: number; ly: number; a: "middle"; human?: boolean }[] = [
  { namn: "Avläsning", ikon: "scan", x: C, y: C - R, lx: C, ly: C - R - 42, a: "middle" },
  { namn: "Kontroller", ikon: "shield", x: C + R, y: C, lx: C + R, ly: C + 50, a: "middle" },
  { namn: "Inlärning", ikon: "ledger", x: C, y: C + R, lx: C, ly: C + R + 50, a: "middle" },
  { namn: "Godkänn", ikon: "sign", x: C - R, y: C, lx: C - R, ly: C + 50, a: "middle", human: true },
];

export function Kretslopp() {
  const ref = usePausUtanfor<HTMLDivElement>();
  return (
    <div ref={ref} className="fbana kl">
      <svg className="kl-svg" viewBox="0 -18 420 442" aria-hidden="true" focusable="false">
        <defs>
          <linearGradient id="kl-g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#5DD3DE" />
            <stop offset="1" stopColor="#93A6F5" />
          </linearGradient>
        </defs>
        <circle className="kl-ring2" cx={C} cy={C} r="62" />
        <circle className="kl-ring3" cx={C} cy={C} r="96" />
        <circle className="fb-track" cx={C} cy={C} r={R} />
        <circle className="kl-prog" cx={C} cy={C} r={R} pathLength={1} stroke="url(#kl-g)" transform={`rotate(-90 ${C} ${C})`} />
        <g className="kl-hub" transform={`translate(${C} ${C})`}>
          <circle className="kl-puls" r="30" />
          <rect x="-20" y="-20" width="40" height="40" rx="12" />
          <path d="M-8 0.5 L-2.5 6 L8.5 -6" />
        </g>
        {/* Signalen: en grupp som roterar runt mitten med en prick överst. */}
        <g className="kl-snurr">
          <circle cx={C} cy={C} r={R + 12} className="kl-osynlig" />
          <circle cx={C} cy={C - R} r="12" className="kl-dot-halo" />
          <circle cx={C} cy={C - R} r="4.5" className="kl-dot" />
        </g>
        {NODER.map((n, i) => (
          <g key={n.namn}>
            <g className={`fb-nod l${i + 1}` + (n.human ? " human" : "")} transform={`translate(${n.x} ${n.y})`}>
              <circle className="fb-halo" r="40" />
              <circle className="fb-disk" r="27" />
              <circle className="fb-ring" r="27" />
              <g className="fb-ikon" transform="translate(-11 -11) scale(0.9167)"><IkonG namn={n.ikon} /></g>
            </g>
            <text className={"fb-t kl-t" + (n.human ? " pers" : "")} x={n.lx} y={n.ly} textAnchor={n.a}>{n.namn}</text>
          </g>
        ))}
      </svg>
    </div>
  );
}
